<template>
  <div>
    <div v-if="detailEcheancePaiement.length === 0">
      <p>{{ $t('echeancierPaiement.childrow.noReglement')}}</p>
    </div>
    <v-client-table :data="detailEcheancePaiement"
                    :columns="columns"
                    :options="options"
                    ref="tableInfoEcheance"
    v-else>
      <div slot="dateReglement" slot-scope="props">
        <router-link-blank v-if="hasLink(props.row)"
          :to="{name: props.row.idRemiseBancaire ? 'c.bodac.remises_bancaires' : 'c.bodac.factures',
          params: {id: props.row.idRemiseBancaire ? props.row.idRemiseBancaire : props.row.idFacture
          }}" :message="props.row.dateReglement | formatDate"></router-link-blank>
          <span v-else>
            {{ props.row.dateReglement | formatDate}}
          </span>
      </div>
      <div slot="montantPaye" slot-scope="props" class="right">
        {{ props.row.montant | formatDevise }}
      </div>
      <div slot="modePaiement" slot-scope="props">
        {{ getModeReglement(props.row) }}
      </div>
    </v-client-table>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, TEXTS } from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import getDetailEcheancePaiement from '@/services/echeancePaiement/getDetailEcheancePaiement';
import { FACTURE_SOUS_TYPE } from '@/configuration/facture/factureConf';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    data: Object,
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      detailEcheancePaiement: [],
      listeSousType: FACTURE_SOUS_TYPE,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
    columns() {
      return ['dateReglement', 'montantPaye', 'typeDePiece', 'libelle', 'referenceReglement',
        'modePaiement'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          dateReglement: this.$i18n.t('echeancierPaiement.childrow.payeLe'),
          montantPaye: this.$i18n.t('echeancierPaiement.childrow.montant'),
          modePaiement: this.$i18n.t('echeancierPaiement.childrow.modePaiement'),
          referenceReglement: this.$i18n.t('echeancierPaiement.childrow.referenceTire'),
          typeDePiece: this.$i18n.t('echeancierPaiement.childrow.typeDePiece'),
          libelle: this.$i18n.t('echeancierPaiement.childrow.libelle'),
        },
        texts: texts,
        filterable: false,
        columnsClasses: {
          dateReglement: 'width-250',
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
      };
    },
    afficherLien() {
      return this.checkIfCurrentSociety(this.data.tiers.societeId);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    hasLink(echeance) {
      if (echeance.typeDePiece === mouvementClientConf.FACTURE
        || echeance.typeDePiece === mouvementClientConf.ACOMPTE
        || echeance.typeDePiece === mouvementClientConf.AVOIR) {
        return true;
      }
      if (echeance.typeDePiece === mouvementClientConf.REGLEMENT
        && this.afficherLien) return true;
      return false;
    },
    getModeReglement(ligneEcheance) {
      const modeReglement = this.modesReglement.find(
        modeReglement => modeReglement.id === ligneEcheance.modeReglementId,
      );
      if (modeReglement) return modeReglement.libelle;
      if (ligneEcheance.sousType) {
        const sousTypeFind = this.listeSousType.find((sousType) => {
          return sousType.code === ligneEcheance.sousType;
        });
        if (sousTypeFind) return this.$i18n.t(sousTypeFind.libelle);
      }
      return null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      if (!this.data.detail || this.data.detail.length === 0) {
        this.data.detail = await getDetailEcheancePaiement(this.data.id);
      }
      this.detailEcheancePaiement = this.data.detail;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
